import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=55ef3250"
import script from "./Verified.vue?vue&type=script&lang=js"
export * from "./Verified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports